<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/partnership" >Partnership Opportunities</a></li>
                            <li><a routerLink="/commercial" class="">President’s & Captain’s Clubs </a></li>
                            <li><a routerLink="/players-sponsor">Entry Level Sponsorship</a></li>
                            <li><a routerLink="/boundary">The Boundary Club</a></li>
                            <li><a routerLink="/advertising">LED Big Screen Advertising</a></li>
                            <li><a routerLink="/officialpartners" class="">Official Partners</a></li>
                            <li><a routerLink="/indiafixture" class="active">India Fixture</a></li>
                            <li><a routerLink="/hospitality">Match Day Hospitality</a></li>
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">

        </div>
    </div>
    <div class="commercial-bottom-section cf">
        <div class="container">
            <div class="fixture-vector-image">
                <div class="fixture-vector-image-inner">
                    <img src="assets/images/ic-logo.png">
                </div>
            </div>
            <div class="fixture-season-detail">
                <ul>
                    <li>
                        <a href="javascript:void(0)" class="season-top">
                            <select id="select_tab" (change)="tabaction()">
                                <optgroup>
                                    <option value="{{sesson?.season_type_id}}" id="{{sesson?.season_type_id}}" *ngFor="let sesson of seasontypeList?.data">{{sesson?.title}} Season</option>
                                    <!-- <option value="saab">2020 Season</option>
                                    <option value="mercedes">2019 Season</option>                                -->
                                </optgroup>
                              </select>
                            <!-- <ul class="fixture-season-list">
                                <li><a href="javascript:void(0)">2020 Season</a></li>
                                <li><a href="javascript:void(0)">2020 Season</a></li>
                                <li><a href="javascript:void(0)">2020 Season</a></li>
                            </ul> -->
                        </a>
                    </li>
                </ul>
            </div>
        </div>
            <div class="fixture-season-tab-section cf">
                    <div class="fixture-season-tab-detail">
                        <ul class="maintab" >
                            <li class="courses-name " [ngClass]="{active: i == 0 }" id="tab-{{tab?.commercial_fixture_type_id}}" *ngFor="let tab of fixturetypeList?.data; let i = index"><a >{{tab?.title}}</a></li>
                            <!-- <li class="courses-name " id="international-fixture"><a href="#">International Fixture</a></li>
                            <li class="courses-name " id="women-one-day"><a href="#"> Women’s One Day</a></li> -->
                        </ul>
                    </div>
                    <div class="fixture-season-tab-content-detail course-main-content   cf" [ngClass]="{active: i == 0 }" id="tab-{{tab?.commercial_fixture_type_id}}-content" *ngFor="let tab of fixturetypeList?.data; let i = index">
                        <div class="container">
                           <div class="fixture-season-tab-content-top" *ngIf="tab?.commercial_fixture?.length > 0">
                                <div class="club-fischer-detail" *ngFor="let tabcontent of tab?.commercial_fixture">
                                    <div class="club-fischer-image">
                                        <img [src]="tabcontent?.image">
                                    </div>
                                    <div class="club-fischer-content">
                                        <h3>{{tabcontent?.title}}</h3>
                                        <div class="club-fischer-text" [innerHTML]="tabcontent?.description">
                                            <p>The Uptonsteel County Ground is set to play host to the global superstars of Test cricket this summer as Virat Kohli and his Indian team travel to Leicestershire.</p>
                                            <p>India visit England for the alternate tour following England’s tour of India that begins in February.</p>
                                            <p>The two nations are set to battle it out in a five-Test series throughout August and September, and India will travel to the Uptonsteel County Ground for their final warm-up fixture.</p>
                                            <p>A star-studded India side that includes two top-ten Test allrounders, three top-ten Test batsmen and two top-ten Test bowlers will take on India A in a red ball fixture from Wednesday, July 28 to Saturday, July 31.</p>
                                            <p>Leicestershire County Cricket Club Chair, Mehmooda Duke M.B.E., D.L. said: “We are really proud to be hosting such a prestigious fixture here at the Uptonsteel County Ground this summer.</p>
                                            <p>“It will be a unique opportunity for cricket fans from across the region to see these global stars in action over four days in their final warm-up game before the Test series with England.</p>
                                        </div>
                                        <div class="club-fischer-btn" *ngIf="tabcontent?.redirect_url">
                                            <a href="{{tabcontent?.redirect_url}}" target="_blank">VIEW DETAILS</a>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="club-fischer-detail">
                                    <div class="club-fischer-image">
                                        <img src="assets/images/commercial-img.jpg">
                                    </div>
                                    <div class="club-fischer-content">
                                        <h3>England women's international fixtures for summer 2021</h3>
                                        <div class="club-fischer-text">
                                            <p>The Uptonsteel County Ground is set to play host to the global superstars of Test cricket this summer as Virat Kohli and his Indian team travel to Leicestershire.</p>
                                            <p>India visit England for the alternate tour following England’s tour of India that begins in February.</p>
                                            <p>The two nations are set to battle it out in a five-Test series throughout August and September, and India will travel to the Uptonsteel County Ground for their final warm-up fixture.</p>
                                            <p>A star-studded India side that includes two top-ten Test allrounders, three top-ten Test batsmen and two top-ten Test bowlers will take on India A in a red ball fixture from Wednesday, July 28 to Saturday, July 31.</p>
                                            <p>Leicestershire County Cricket Club Chair, Mehmooda Duke M.B.E., D.L. said: “We are really proud to be hosting such a prestigious fixture here at the Uptonsteel County Ground this summer.</p>
                                            <p>“It will be a unique opportunity for cricket fans from across the region to see these global stars in action over four days in their final warm-up game before the Test series with England.</p>
                                        </div>
                                        <div class="club-fischer-btn">
                                            <a href="javascript:void(0)">VIEW DETAILS</a>
                                        </div>
                                    </div>
                                </div> -->
                           </div>
                       </div>
                    </div>
            </div>
    </div>
</section><!-- page ends-->